import { ExclamationIcon } from "@heroicons/react/outline";
import React from "react";
import { useTranslation } from "react-i18next";
import { classNames, transformAmplifyError } from "../../Utils";

export const ErrorList = ({
  className = "",
  title = "Error",
  message = "",
  errors = [],
}) => {
  const { t } = useTranslation();

  function renderMessage(text) {
    return <p className="text-gray-500">{t(text)}</p>;
  }

  function renderList(items) {
    if (items.length === 1) {
      return renderMessage(items[0]);
    }

    return (
      <ul className="list-disc pl-5 space-y-1 text-sm text-gray-500 text-left">
        {items.map((item, index) => (
          <li key={`${index}`}>{t(item)}</li>
        ))}
      </ul>
    );
  }

  function renderMessages() {
    const errorMessages = transformAmplifyError(errors);
    if (errorMessages.length > 0) {
      return renderList(errorMessages);
    } else if (message) {
      return renderMessage(message);
    }
    return null;
  }

  return (
    <div
      className={classNames(
        className,
        "flex flex-col justify-center text-center text-sm"
      )}
    >
      <ExclamationIcon className="mx-auto h-12 w-12 text-yellow-500" />
      <h3 className="mt-2 font-medium text-slate-900">{t(title)}</h3>
      {renderMessages()}
    </div>
  );
};
